import axios, { AxiosResponse } from "axios";
import { BufferAttribute, BufferGeometry, Points, PointsMaterial } from "three";
import { Common } from "../../../common/src";
import { Viewer } from "../viewer";

export class Trajectory {
  private _mesh: Points;
  private _geometry: BufferGeometry;
  private _material: PointsMaterial;
  private _pointArray: number[] = [];
  private _viewer: Viewer;

  constructor(viewer: Viewer) {
    this._mesh = new Points();
    this._geometry = new BufferGeometry();
    this._material = new PointsMaterial({
      color: 0x00ff00,
      vertexColors: false,
      size: 5,
      sizeAttenuation: false,
    });
    this._viewer = viewer;
  }

  public getMesh(): Points {
    return this._mesh;
  }

  public loadTrajectory(
    url: string,
    abortController: AbortController
  ): Promise<boolean> {
    this._pointArray = [];
    const offset = this._viewer.getOffset();
    return new Promise(async (resolve, rejects) => {
      try {
        await axios
          .get(url, { withCredentials: true, signal: abortController.signal })
          .then((res: AxiosResponse<Common.PointsPhotoGraphData>) => {
            if (res.data !== undefined) {
              for (let i = 0; i < res.data?.points.length; i++) {
                const current_data = res.data.points[i];
                this._pointArray.push(current_data.x + offset.x);
                this._pointArray.push(current_data.y + offset.y);
                this._pointArray.push(current_data.z + offset.z);
              }
            }
          });
        const pointF32Array = new Float32Array(this._pointArray.length);
        pointF32Array.set(this._pointArray);
        this._geometry.setAttribute(
          "position",
          new BufferAttribute(pointF32Array, 3)
        );

        this._mesh.geometry = this._geometry;
        this._mesh.material = this._material;
        resolve(true);
      } catch (err) {
        console.log(`Error: ${err}`);
        rejects(false);
      }
    });
  }
}